import { Theme, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Issue } from '../../types/issues-types';

const IssueSeverityCell: FC<
  React.PropsWithChildren<IssueSeverityCellProps>
> = ({ severity }) => {
  const theme = useTheme();
  const { classes } = useStyles();
  let color;
  if (!severity) {
    color = theme.palette.categoryRiskColor.info;
  } else {
    color = theme.palette.categoryRiskColor[severity.toLowerCase()];
  }
  return (
    <Typography component='div' variant='body2' color={color} fontWeight='bold'>
      <span
        style={{
          backgroundColor: color,
        }}
        className={classes.legendIcon}
      />
      {severity}
    </Typography>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  legendIcon: {
    marginInlineEnd: theme.spacing(0.8),
    height: 6,
    width: 6,
    borderRadius: '50%',
    display: 'inline-block',
  },
}));
export interface IssueSeverityCellProps extends Pick<Issue, 'severity'> {}

export default IssueSeverityCell;
